import { useCallback, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Formik } from "formik";
import { LabelWithValue } from "../components/label-with-value";
import { addUrlLinkValidationSchema } from "../../../constants/validationSchema";
import { PublishDocumentList } from "../components/document/publish-document-list";

const LinkDocumentModal = (props: any) => {
  const { onClose, isOpen, onLinked, isUrl, data, onPicked, listId, isDepartment } = props;
  const [selectedDocuments, setSelectedDocuments] = useState<any>([]);

  const onSelectedDocument = (file: any, isSelected: boolean) => {
    if (file.id === data?.fileId) return;

    const documents = selectedDocuments;
    var selectedFile = documents.find((f: any) => f.id === file.id);

    if (selectedFile && isSelected === false) {
      const index = documents.indexOf(selectedFile);
      documents.splice(index, 1);
    } else if (!selectedFile && isSelected) {
      documents.push(file);
    }
    setSelectedDocuments(documents);
  };

  const onSelectedFolder = useCallback((folder: any) => {
    setSelectedDocuments(folder);
  }, []);

  const handleLink = () => {
    if (data) onLinked(selectedDocuments);
    else if (isDepartment) {
      onClose();
      onPicked(selectedDocuments);
    } else {
      onPicked(selectedDocuments[selectedDocuments?.length - 1]);
      onClose();
    }
  };

  const handleOnSubmit = async (values: any) => {
    const { name, url } = values;
    onLinked([{ name, url }]);
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered size={isUrl ? "lg" : "xl"} className="link-document-modal">
      <Formik
        validationSchema={addUrlLinkValidationSchema}
        onSubmit={handleOnSubmit}
        initialValues={{
          name: "",
          url: "",
        }}
      >
        {({ handleSubmit, setFieldValue, handleChange, isValid, values, errors }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>{isUrl ? "Thêm liên Url" : "Liên kết tài liệu"}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-4 px-4">
              {isUrl ? (
                <>
                  <Form.Group as={Row} controlId="validationCustom01">
                    <Col xs={2}>
                      <LabelWithValue label={"Tên"} value={""} />
                    </Col>
                    <Col xs={10}>
                      <Form.Control
                        type="text"
                        placeholder=""
                        name="name"
                        value={values.name}
                        onChange={handleChange}
                        isInvalid={!!errors.name}
                      />
                      <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="validationCustom02">
                    <Col xs={2}>
                      <LabelWithValue label={"URL"} value={""} />
                    </Col>
                    <Col xs={10}>
                      <Form.Control
                        type="text"
                        placeholder=""
                        name="url"
                        value={values.url}
                        onChange={handleChange}
                        isInvalid={!!errors.url}
                      />
                      <Form.Control.Feedback type="invalid">{errors.url}</Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                </>
              ) : (
                <>
                  <Form.Group as={Row} controlId="validationCustom01">
                    <Col xs={12}>
                      <PublishDocumentList
                        isShowCheckColumn={true}
                        onSelectedDocument={onSelectedDocument}
                        isOpen={isOpen}
                        listId={listId}
                        // isDepartment={isDepartment}
                        onSelectedFolder={onSelectedFolder}
                      />
                    </Col>
                  </Form.Group>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={onClose} variant="secondary">
                Đóng hộp thoại
              </Button>
              {isUrl ? (
                <Button disabled={!isValid} type="submit" variant="info">
                  Thêm
                </Button>
              ) : data ? (
                <Button onClick={handleLink} variant="info">
                  Liên kết
                </Button>
              ) : (
                <Button onClick={handleLink} variant="info">
                  Chọn
                </Button>
              )}
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default LinkDocumentModal;
